module.exports = __webpack_public_path__ + "media/images/health-systems-0bb61cca7ac3276425cfd83fa62932e5.png";